import 'normalize.css';
import '@/styles/index.scss';
import '@/utils/flexible';

import $ from 'jquery';

import SvgIcon from '@/components/SvgIcon/plugins';

window.jQuery = $;
window.$ = $;

import { PiniaVuePlugin } from 'pinia';
import { Lazyload } from 'vant';
import { Toast } from 'vant';
import Vue from 'vue';
import { VueHammer } from 'vue2-hammer/index';

import pinia from '@/store';
import initWxShare from '@/utils/initWxShare';

import App from './App.vue';
import router from './router';

Toast.setDefaultOptions({ position: 'top' });
VueHammer.customEvents = {
  panmove: { type: 'pan', pointers: 1 },
  doubletap: { type: 'tap', event: 'doubletap', taps: 2 }
};

initWxShare({
  desc: '"南方⁺"创造更多价值！',
  title: '电子画册',
  icon: process.env.VUE_APP_LOGO,
  shareUrl: window.location.href
});

if (process.env.VUE_APP_ENV === 'test') {
  const eruda = require('eruda');
  eruda.init();
}

Vue.config.productionTip = false;

Vue.use(SvgIcon)
  .use(Lazyload, {
    lazyComponent: true
  })
  .use(Toast)
  .use(VueHammer)
  .use(PiniaVuePlugin);

new Vue({
  router,
  pinia,
  render: (h) => h(App)
}).$mount('#app');
